import React, { createContext, useEffect, useRef, useState } from 'react';
import DropdownHeader from './dropdown-header';
import DropdownMenu from './dropdown-menu';
import { DropDownType } from './dropdown-props';
import { DropdownDiv } from './styles';

/**
 *
 * @param {object { icon: object | null, title: string }} header
 * @param {array of object { value: string, label: string, icon: {dark: object, light: object} | null }} options
 * @param {array of object { value: string, label: string, icon: {dark: object, light: object} | null }} defaultOptions
 * @param {string: default | toggle} type
 * @returns
 */
export const DropDownContext = createContext(null);

const CustomDropDown = ({
  header,
  options,
  defaultOptions = [],
  type = DropDownType.DEFAULT,
  onSelection = null,
  onOpenMenu = null,
  onCloseMenu = null,
  showDropdownIcon = false,
  isMultiselect = false,
  shouldHandleClickOutSide = true,
  isDraggable = false,
  style,
  menuWidth,
}) => {
  const [isOpen, toggleDrawer] = useState(false);
  const [selectedOptions, setSelectedOptions] = useState(
    defaultOptions ? defaultOptions : null
  );
  const [hoveredOnOption, sethoveredOnOption] = useState(null);

  const optionRef = useRef(null);

  const handleClickOutside = (event) => {
    if (
      optionRef.current &&
      !optionRef.current.contains(event.target) &&
      isOpen
    ) {
      if (!!onCloseMenu) onCloseMenu(selectedOptions);
      toggleDrawer(false);
    }
  };

  // if default options changes after API call
  useEffect(() => {
    if (JSON.stringify(defaultOptions) !== JSON.stringify(selectedOptions)) {
      setSelectedOptions(defaultOptions);
    }
  }, [defaultOptions]);

  const toggleMenu = (e) => {
    const newState = !isOpen;
    if (newState) {
      if (!!onOpenMenu) onOpenMenu(e);
    } else {
      if (!!onCloseMenu) onCloseMenu(e);
    }
    toggleDrawer(newState);
  };

  useEffect(() => {
    if (!shouldHandleClickOutSide) return;
    // Attach the event listener to the document
    document.addEventListener('mousedown', handleClickOutside);

    // Cleanup the event listener from the document when the component unmounts
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [selectedOptions, isOpen, shouldHandleClickOutSide]);

  return (
    <DropDownContext.Provider
      value={{
        header,
        options,
        isOpen,
        selectedOptions,
        hoveredOnOption,
        type,
        showDropdownIcon,
        isMultiselect,
        menuWidth,

        toggleDrawer,
        setSelectedOptions,
        sethoveredOnOption,
        onSelection,
        onOpenMenu,
        onCloseMenu,
        toggleMenu,
        isDraggable,
      }}
    >
      <DropdownDiv
        ref={optionRef}
        style={style}
        onClick={(e) => {
          e.stopPropagation();
          toggleMenu(e);
          sethoveredOnOption(null);
        }}
      >
        <DropdownHeader />
        <DropdownMenu />
      </DropdownDiv>
    </DropDownContext.Provider>
  );
};

export { CustomDropDown };
